import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['root', 'container', 'title', 'description', 'titleContainer', 'icon', 'close'];
var baseStyle = {
  container: {
    alignItems: 'start',
    borderRadius: 'md',
    boxShadow: 'lg',
    pr: 8,
    textAlign: 'left',
    width: '100%',
    maxWidth: '30rem',
    minWidth: '16.85rem'
  },
  titleContainer: {
    display: 'flex'
  },
  title: {
    mr: 2,
    textStyle: 'lead-lg-bold'
  },
  description: {
    textStyle: 'body-sm'
  },
  icon: {
    flexShrink: 0,
    mr: 3,
    width: '1.25rem'
  },
  close: {
    position: 'absolute',
    right: 3,
    top: 3,
    _hover: {
      bg: 'transparent'
    }
  }
};
var variants = {
  banner: {
    container: {
      width: '100vw',
      maxWidth: 'none',
      minWidth: 'none',
      minHeight: ['5.25rem', '6.25rem'],
      alignItems: 'center',
      borderRadius: 'none',
      borderBottomWidth: '0.125rem',
      borderLeftWidth: '0',
      pr: 8,
      m: 0
    },
    title: {
      mr: 0,
      textAlign: ['left', 'center']
    },
    description: {
      textStyle: ['body-sm', 'body-lg'],
      display: 'block',
      textAlign: ['left', 'center'],
      mt: 1,
      pl: ['2rem', '3.125rem'],
      pr: ['1.875rem', '3.125rem']
    },
    titleContainer: {
      alignItems: 'flex-start',
      justifyContent: ['flex-start', 'center'],
      pl: [0, '3.125rem'],
      pr: ['1.875rem', '3.125rem']
    },
    close: {
      right: [2, 9],
      top: [4, 8],
      color: 'blue.600'
    }
  }
};
export var Toast = asMultiStyleConfig({
  parts,
  baseStyle,
  variants
});